module.exports = __webpack_public_path__ + "img/newsImg11-32.8893b978.png";